// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"64b7770c","239":"90e1d35f","453":"64b62a01","732":"480cd89f"}[chunkId] + ".chunk.js";
};